import axios from 'axios';

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

// Base URL for the Medical College API
const API_URL = getApiUrl('/MedicalCollege/');

// Create an Axios instance with default headers
const apiClient = axios.create({
  baseURL: API_URL,
});

// Add an interceptor to include the access token in the headers
apiClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("access_token");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

/**
 * Fetch all medical colleges.
 * @returns {Promise} A promise that resolves to the list of medical colleges.
 */
export const fetchMedicalColleges = (page = 1, search = '', filters = {}) => apiClient.get('/', { params: { page, search, ...filters } });

/**
 * Fetch a single medical college by ID.
 * @param {number} id - The ID of the medical college to fetch.
 * @returns {Promise} A promise that resolves to the medical college details.
 */
export const fetchMedicalCollege = (id) => apiClient.get(`medical-colleges/${id}/`);


/**
 * Create a new medical college.
 * @param {Object} data - The data for the new medical college.
 * @returns {Promise} A promise that resolves to the created medical college.
 */
export const createMedicalCollege = (data) => apiClient.post('/', data);

/**
 * Update an existing medical college.
 * @param {number} id - The ID of the medical college to update.
 * @param {Object} data - The updated data for the medical college.
 * @returns {Promise} A promise that resolves to the updated medical college.
 */
export const updateMedicalCollege = (id, data) => apiClient.put(`medical-colleges/${id}/`, data);


/**
 * Delete a medical college.
 * @param {number} id - The ID of the medical college to delete.
 * @returns {Promise} A promise that resolves when the deletion is successful.
 */
export const deleteMedicalCollege = (id) => apiClient.delete(`medical-colleges/${id}/`);

/**
 * Filter medical colleges based on specialization, qualification, and passing out month.
 * @param {Object} filters - The filter parameters (e.g., specialization, qualification, passoutmonth).
 * @returns {Promise} A promise that resolves to the filtered list of medical colleges.
 */
export const filterMedicalColleges = (filters) => apiClient.get('filter-medical-colleges/', { params: filters });